import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import KogAutoCompleteVehicleControlled from '@/main/components/shared/inputAutoComplete/autoCompleteVehicleControlled';

import { KeyValue } from '@/main/models/common';
import { StatusRegisterEnum } from '@/main/services/enum/StatusRegisterEnum';
import { getTranslateByKey, isNullUndefined, isValueQueryParams } from '@/main/services/utils';
import { getManufacturers, resetReducerManufacturers, useManufacturerReducer } from '@/main/store/vehicle/manufacturer';
import { useDinamicFiltersMappingCodes } from './dinamicFiltersMappingCodes';


export const INITIAL_FORM_STATE_MAKE = {
  manufacturer: null as KeyValue | null,
};

export type IFormFiltersMappingTypeMake = typeof INITIAL_FORM_STATE_MAKE

interface IFiltersMappingTypeMakeProps {
}
function FiltersMappingTypeMake({
}: IFiltersMappingTypeMakeProps) {
  const dispatch = useDispatch();
  const {
    isEdit,
    keyReducer,
    watcherCountry,
    isRequiredField
  } = useDinamicFiltersMappingCodes();
  const { isolated: manufacturer } = useManufacturerReducer(keyReducer);
  const {
    control,
    resetField,
    setValue
  } = useFormContext<IFormFiltersMappingTypeMake>();

  useEffect(() => {
    if (!isValueQueryParams(watcherCountry)) {
      resetField('manufacturer');
    }
    if (isNullUndefined(watcherCountry)) return;

    dispatch(getManufacturers({ guidCountry: String(watcherCountry.key) }, keyReducer));

    return () => {
      dispatch(resetReducerManufacturers(keyReducer));
    }
  }, [JSON.stringify(watcherCountry?.key)])

  const disabledManufacturer = isNullUndefined(manufacturer.data) || manufacturer.data.length === 1

  return (
    <>
      <KogAutoCompleteVehicleControlled
        id='id-mappingCode-select-manufacturer'
        nameCustom='manufacturer'
        label={getTranslateByKey('information.manufacturer')}
        isDefaultValueUnique
        control={control}
        setValueCustom={setValue}
        options={manufacturer.data}
        isLoading={manufacturer.isLoading}
        disabled={disabledManufacturer}
        rulesCustom={{ required: isRequiredField('manufacturer') }}
        onChangeCustom={() => { }}
      />
    </>
  )
}

export default FiltersMappingTypeMake